module.exports = __webpack_public_path__ + "img/logo.71ecace1.png";